export const notFoundPhrases = [
  { code: "en", text: "Page not found" },
  { code: "es", text: "Página no encontrada" },
  { code: "fr", text: "Page introuvable" },
  { code: "de", text: "Seite nicht gefunden" },
  { code: "it", text: "Pagina non trovata" },
  { code: "pt", text: "Página não encontrada" },
  { code: "ru", text: "Страница не найдена" },
  { code: "ja", text: "ページが見つかりません" },
];
